exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-1d8b5709] {\r\n  font-size: 16px;\r\n  line-height: 20px;\r\n  letter-spacing: -0.256px;\n}\n.text-bold[data-v-1d8b5709] {\r\n  font-weight: 700;\n}\n[data-v-1d8b5709] .button {\r\n  display: block;\r\n  margin: 40px auto 0;\n}\r\n", ""]);

// exports
